const { container } = require('@/container');
const { populate } = require('@/functions/objects');
const { toBool, toNullableInt, toString } = require('@/functions/transform');

/**
 * @param {object} [data]
 *
 * @constructor
 */
const Address = function (data = {}) {
    /**
     * ID of address saved in the database, if this was an existing address.
     *
     * @type {number|null}
     */
    this.ID = null;

    /**
     * Different to the ID. Creates the relationship between the account and address.
     *
     * @type {number|null}
     */
    this.savedAddressID = null;

    this.formattedAddress = '';

    this.house = '';
    this.street = '';
    this.town = '';
    this.county = '';
    this.state = '';
    this.postcode = '';
    this.defaultBilling = false;

    /**
     * @type {Country|null}
     */
    this.country = null;

    populate(this, data);
};

Address.prototype = {
    getHydrationMap() {
        return {
            ID: {
                field: ['ID', 'addressID'],
                transform: toNullableInt,
            },
            savedAddressID: toNullableInt,
            house: toString,
            street: toString,
            town: toString,
            county: toString,
            state: toString,
            postcode: toString,
            defaultBilling: toBool,
        };
    },

    /**
     * @param {object} data
     */
    afterHydration(data) {
        const countryManager = container.countryManager;

        if (countryManager) {
            this.country = countryManager.findByData(data);
        }
    },

    getFormattedAddress() {
        return [
            this.house,
            this.street,
            this.town,
            this.county,
            this.state,
            this.postcode,
        ].filter((n) => !!n).join(', ');
    },

    clear() {
        this.formattedAddress = '';

        this.savedAddressID = null;
        this.house = '';
        this.street = '';
        this.town = '';
        this.county = '';
        this.state = '';
        this.postcode = '';
        this.defaultBilling = false;
        // Don't clear the country.
    },

    isEmpty() {
        // We'll ignore 'Country' as this is often set by default
        // and 'defaultBilling' as it is irrelevant.
        return !this.house
                && !this.street
                && !this.town
                && !this.county
                && !this.state
                && !this.postcode;
    },

    hasData() {
        return !this.isEmpty();
    },

    toServerData() {
        return {
            addressID: this.ID,
            ID: this.ID,
            savedAddressID: this.savedAddressID,

            // Provide the country in all the different forms various API endpoints require.
            country: this.country ? this.country.code : '',
            countryCode: this.country ? this.country.code : '',
            countryID: this.country ? this.country.ID : '',

            house: this.house,
            street: this.street,
            town: this.town,
            county: this.county,
            state: this.state,
            postcode: this.postcode,
            defaultBilling: this.defaultBilling,
        };
    },

    /**
     * @returns {boolean}
     */
    isPrimary() {
        return !!this.defaultBilling;
    },
};

module.exports = Address;
